// import components
import { Icon } from '@sdb/planning-ui';
import { styled } from '@mui/material';

/** The kebab that opens where a planner can go for this entity. */
export const EntityActionsIcon = styled(Icon)({
  width: 16
});
